import React, { useState,useEffect } from "react";
import axios from "axios";
import {
    Modal,
    Card,
    Form,
    Button,
} from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSubscriptionsPackage, updateSubscriptionPackage } from "../../api/subscriptionService";
export default function SubscriptionPackages() {
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    // const handleShow2 = () => setShow2(true);
    const [subscriptionsPackage, setSubscriptionsPackage] = useState([]);
    const [editingPackage, setEditingPackage] = useState(null);
    const [features, setFeatures] = useState('');
    const [Title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [Price, setPrice] = useState('');
    const [value, setValue] = useState('');
    const [Status, setStatus] = useState('');
    const [searchText, setSearchText] = useState('');
    const getStatusStyle = (status) => {
      switch (status) {
        case 'activate':
          return {
            backgroundColor: 'rgba(40, 199, 111, 0.12)',
            color: '#28c76f',
            padding: '5px 10px',
            borderRadius: '5px',
            display: 'inline-block'
          };
        case 'deactivate':
          return {
            backgroundColor: 'rgba(146, 0, 0, 0.12)',
            color: '#920000',
            padding: '5px 10px',
            borderRadius: '5px',
            display: 'inline-block'
          };
        default:
          return {};
      }
    }; 


    const fetchSubscriptionsPackage = (page, size) => {
        setLoading(true);
        getSubscriptionsPackage()
          .then((response) => {
            if (response.data) {
                setSubscriptionsPackage(response.data);
     
            }
          })
          .catch((error) => console.error("Error fetching users", error))
          .finally(() => setLoading(false));
      };
    
      useEffect(()=>{
        fetchSubscriptionsPackage()
      },[])


      const handleShow2 = (packageData) => {

        setEditingPackage(packageData);
        setTitle(packageData.planName);
        setPrice(packageData.price);
        setStatus(packageData.status === 'activate' ? '1' : '2');
        setFeatures(packageData.features);
        setShow2(true);
    };

    const handleUpdatePackage = () => {
        const updatedPackage = {
            packageId: editingPackage._id,
            planName: Title,
            price: Price,
            status: Status === '1' ? 'activate' : 'deactivate',
            features: features
        };

        updateSubscriptionPackage(updatedPackage)
        .then((response) => {
            console.log('==========response',response);
            if (response.status==200) {
                toast.success("Subscription updated successfully");
                handleClose2();
                fetchSubscriptionsPackage();
            } else {
                console.error("Update failed:", response.data.message || "Unknown error");
            }
        })
        .catch((error) => {
            console.error("Error updating package", error.response?.data || error.message);
        });
    };

    const columns = [
        // {
        //   name: 'Plan ID',
        //   width: '140px',
        //   selector: row => row._id,
        //   sortable: true,
        //   cell: (row) => row._id,
        // },
        {
          name: 'Plan Name',
          width: '160px',
          selector: row => row.planName,
          sortable: true,
          cell: (row) => row.planName,
        },
        {
            name: 'Price',
            width: '140px',
            selector: row => row.price, 
            sortable: true,
            cell: (row) => row.price,
        },
        {
            name: 'Features',
            width: '340px',
            selector: row => row.features, 
            sortable: true,
            cell: row => (
                <div
                    className="truncate"
                    title={row.features.replace(/<br\/>/g, '\n')}
                    dangerouslySetInnerHTML={{ __html: row.features }}
                />
            ),
        },
        {
            name: 'Number of Subscribers',
            width: '230px',
            selector: row => row.subscribersCount, 
            sortable: true,
            cell: (row) => row.subscribersCount,
        },
        {
          name: 'Status',
          width: '150px',
          selector: row => row.Status,
          sortable: true,
          cell: (row) => <span  style={getStatusStyle(row.status)}>{row.status}</span>
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <Link className="btnedit" onClick={() => handleShow2(row)}>
                        <Icon icon="tabler:pencil"></Icon>
                    </Link>
                </>
            ),
        },
    ];
  

  const filteredData = subscriptionsPackage.filter(
    item => {
      const searchStr= searchText.toLocaleLowerCase();
      return (
        item.planName.toLowerCase().includes(searchStr) ||
        item.price.includes(searchStr) ||
        item.status.toLowerCase().includes(searchStr) ||
        item._id.toLowerCase().includes(searchStr)
      )
    }
  )
    return (
        <React.Fragment>
            <Card>
                <Card.Header className="py-4">
                    <h5>Subscription Packages</h5>
                </Card.Header>
                <Card.Body>
                    <div className="text-end mb-3">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="searchfield"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                    </div>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        responsive
                        progressPending={loading}
                        className="custom-table"
                    />
                </Card.Body>
            </Card>
            <Modal size="lg" show={show2} onHide={handleClose2} centered>
        <Modal.Header closeButton>
            <Modal.Title><h2 className="modalhead">Edit Subscription Package</h2></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group className="mb-3 form-group">
                    <Form.Label>Title</Form.Label>
                    <Form.Control type="text" placeholder="Enter Title" value={Title} onChange={(e) => setTitle(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3 form-group">
                    <Form.Label>Price</Form.Label>
                    <Form.Control type="text" placeholder="Enter Price" value={Price} onChange={(e) => setPrice(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3 form-group">
                    <Form.Label>Status</Form.Label>
                    <Form.Select value={Status} onChange={(e) => setStatus(e.target.value)} >
                        <option value="select">Select Status</option>
                        <option value="1">Activate</option>
                        <option value="2">Deactivate</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3 form-group">
                    <Form.Label>Features</Form.Label>
                    <ReactQuill theme="snow" value={value} onChange={setValue} />
                    {/* <CKEditor
                        editor={ ClassicEditor }
                        data={features}
                        onChange={ ( event, editor ) => {
                            const data = editor.getData();
                            setFeatures(data);
                        } }
                    /> */}
                </Form.Group>
            </Form>
            <Button className="btn btn-primary px-4 w-100" onClick={handleUpdatePackage}>
                Update
            </Button>
        </Modal.Body>
    </Modal>
    <ToastContainer />
        </React.Fragment>
    );
}